<div class="rounded-2.5xl w-full text-center">
  <div class="px-12 md:px-24 py-4 md:py-10">
    @if (this.braintreeToken) {
      <sdc-add-digital-wallet
        [token]="this.braintreeToken"
        [errorMessage]="this.errorMessage"
        [showCancelButton]="true"
        [showIsDefaultCardCheckbox]="true"
        (cancelClick)="close()"
        (useDefaultCard)="setUseDefaultCard($event)"
        (braintreePayload)="accept($event)"></sdc-add-digital-wallet>
    }
  </div>
</div>
